export default function (input: string): string {
	return input ? input.toUpperCase() : '';
}
